import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import {
  ProjectsList,
  ProjectsListHeader,
} from '@components/Dashboard/components/DashboardProjects/components'
import { ProjectsNotFound } from '@components/Dashboard/components/DashboardProjects/components/ProjectsList/components'
import { Button } from '@octopus-do/octopus-storybook'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useTemplates } from './hooks/useTemplates'
import css from './styles.module.css'

export const Templates: React.FC = () => {
  const dispatch = useDispatch()

  const { own, shared, ready, upsell } = useTemplates()

  const empty = ready && own.length === 0

  const onUpgrade = () => {
    sendGtmEvent(
      GtmTriggerName.TEMPLATE_UPGRADE_CLICK,
      'Upgrade from the templates section'
    )

    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: { planType: 'pro', slideType: 'templates' },
      })
    )
  }

  return (
    <div className={css.templates}>
      <div className={css.body}>
        <ProjectsListHeader title="My templates" />

        {/* No spinner: the lists are fetched with the dashboard, so they are
            normally here already. Until they are, only the heading shows. */}
        {empty && (
          <ProjectsNotFound
            compact
            title="Save any project as a template to see it here"
          >
            {upsell && (
              <Button size="medium" label="Upgrade" onClick={onUpgrade} />
            )}
          </ProjectsNotFound>
        )}

        {own.length > 0 && <ProjectsList projects={own} />}

        {shared.length > 0 && (
          <>
            <ProjectsListHeader title="Gallery" />

            <ProjectsList projects={shared} />
          </>
        )}
      </div>
    </div>
  )
}
